import { useMutation } from '@tanstack/react-query';

import type { MutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useMoveInventoryProductCategoryMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: { parent_id: number | null; ids: number[] };
    }) =>
      HttpClient.request<MutationResponse>({
        method: 'PUT',
        url: params.url,
        data: params.data,
      }),
  });
